import Tooltip from "../Common/Tooltip";
import {ArrowLeft, ArrowRight, ArrowUpRight, HelpCircle} from "react-feather";
import Star from "../Icons/Star";
import SwitchButton from "../Input/Switch";
import React from "react";
import {moment} from "../../services/moment-extensions";

const ReviewsTable = ({
                          tableData,
                          setFeaturedReview,
                          setSelectedReview,
                          setReviewVisibility,
                          setCurrentPage,
                          tablePagination,
                          currentPage
                      }) => {

    return <>
        <table
            className="sl-flex sl-flex-col sl-border-collapse sl-border-spacing-0 sl-bg-white sl-border sl-border-solid sl-border-gray-200 sl-rounded-top-left-lg sl-rounded-top-right-lg sl-shadow-md">
            <thead className="sl-bg-gray-50">

            <tr className="sl-flex  sl-border-0 sl-border-b sl-border-solid sl-border-gray-200">
                <th className="sl-font sl-text-start sl-font-medium sl-text-sm sl-text-gray-700 sl-py-12 sl-pr-16 sl-pl-16 sl-w-54 sl-min-w-54">
                    Reviewer
                </th>

                <th className="sl-font sl-text-start sl-font-medium sl-text-sm sl-text-gray-700 sl-py-12 sl-pl-16  sl-px-16 sl-min-w-41">
                    Client
                </th>

                <th className="sl-font sl-text-start sl-font-medium sl-text-sm sl-text-gray-700 sl-py-12 sl-pl-16  sl-px-16  sl-min-w-32 sl-max-w-32">
                    Date
                </th>

                <th className="sl-font sl-text-start sl-min-w-118 sl-max-w-118 sl-pl-16  sl-py-12 sl-px-16">
                    <span className="sl-font-medium sl-text-sm sl-text-gray-700">Review</span>
                </th>

                <th className="sl-font  sl-display-flex sl-justify-center sl-text-start sl-py-12 sl-px-16 sl-min-w-28">
                    <Tooltip
                        content="This indicates a highlighted review. You can feature only one review.">
                        <div className="sl-h-auto">
                            <HelpCircle size={20}
                                        className="sl-cursor-pointer sl-text-gray-base"/>
                        </div>
                    </Tooltip>
                    <span
                        className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 sl-pl-2">Featured</span>
                </th>

                <th className="sl-font sl-display-flex sl-justify-center sl-text-start sl-py-12 sl-px-16 sl-min-w-28">
                    <Tooltip disabled={false}
                             content="Control whether this review is shown or hidden on your profile page.">
                        <HelpCircle size={20}
                                    className="sl-cursor-pointer sl-text-gray-base"/>
                    </Tooltip>
                    <span
                        className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 sl-pl-2">Visibility</span>
                </th>
            </tr>
            </thead>
            <tbody>

            {tablePagination?.total === 0 && <div className="sl-flex sl-flex-col sl-gap-1 sl-p-12">
                <span className="sl-text-gray-900 sl-text-lg sl-font-medium">No reviews found</span>
                <span className="sl-text-gray-500 sl-text-sm ">Share invite link to gather client reviews.</span>
            </div>
            }


            {tableData.map((item, index) => {
                    const reviewStars = [];
                    let isHalf = (item.overall_score - Math.floor(item.overall_score)) > 0;

                    for (let i = 1; i <= 5; i++) {
                        if (i <= Math.floor(item.overall_score)) {
                            if (item.visibility)
                                reviewStars.push(<Star size={18}/>);
                            else
                                reviewStars.push(<Star size={18} fill={'#FEF0C7'}/>);
                        } else {
                            if (isHalf) {
                                if (item.visibility)
                                    reviewStars.push(<Star size={18} isHalf={isHalf}/>);
                                else
                                    reviewStars.push(<Star size={18} isHalf={isHalf} fill={'#FEF0C7'}/>);
                                isHalf = false;
                            } else
                                reviewStars.push(<Star size={18} fill={'#EAECF0'}/>);

                        }
                    }

                    return <tr className="sl-flex sl-justify-between sl-align-center sl-text-center sl-cursor-default"
                    >
                        <td className="sl-font sl-font-medium sl-text-sm sl-py-16 sl-pr-16 sl-pl-16 sl-w-54 sl-min-w-54 sl-text-start sl-relative">
                            <div className="sl-flex sl-flex-col">
                                        <span
                                            className={`sl-font-normal ${item.visibility ? 'sl-text-gray-900' : 'sl-text-gray-500'} sl-font-medium sl-break-all`}>{item.name}</span>
                                <span className="sl-pt-1 sl-flex sl-flex-row">
                                            {reviewStars}
                                        </span>

                            </div>
                        </td>
                        <td className="sl-font sl-font-medium sl-text-sm sl-py-16 sl-pr-16 sl-pl-16  sl-min-w-41 sl-max-41 sl-text-start sl-relative">
                            <div className="sl-flex sl-flex-col ">
                                        <span
                                            className={`sl-font-normal ${item.visibility ? 'sl-text-gray-900' : 'sl-text-gray-500'} sl-font-medium sl-font sl-break-all`}>{item.client_name}</span>

                            </div>
                        </td>

                        <td className="sl-font sl-font-medium sl-text-sm sl-py-16 sl-pr-16 sl-pl-16  sl-min-w-32 sl-max-w-32 sl-text-start sl-relative">
                            <div className="sl-flex sl-flex-col ">
                                        <span
                                            className={`sl-font-normal ${item.visibility ? 'sl-text-gray-900' : 'sl-text-gray-500'} sl-font-medium sl-font sl-break-all`}>{moment(item.review_date).toMediumDate()}</span>
                            </div>
                        </td>


                        <td onClick={() => setSelectedReview(item.id)}
                            className="sl-font  sl-font-medium sl-text-sm sl-py-16 sl-pr-16 sl-pl-16 sl-min-w-118 sl-max-w-118 sl-text-start sl-relative sl-cursor-pointer">
                                        <span
                                            className={`sl-font-normal  sl-break-all ${item.visibility ? 'sl-text-gray-900' : 'sl-text-gray-500'} sl-ellipsis-two-line sl-font`}>{item.comment ? `"${item.comment}"` : ""}</span>
                            <span
                                className="sl-font-normal sl-text-gray-500 sl-text-xs sl-display-flex sl-mt-1 sl-font">View more details <ArrowUpRight
                                size={16}/></span>

                        </td>

                        <td className="sl-font sl-display-flex sl-justify-center  sl-py-16 sl-pr-16 sl-pl-16 sl-w-28 sl-min-w-28">
                            <input type={'radio'}
                                   checked={item.featured}
                                   disabled={!item.visibility}
                                   name={`radio_${index}`}
                                   onClick={async (e) => {
                                       const isChecked = e.currentTarget.checked;
                                       if (isChecked)
                                           await setFeaturedReview(item.id, false)
                                   }}
                                   onChange={async (e) => {
                                       await setFeaturedReview(item.id, e.currentTarget.checked)
                                   }}
                                   className="sl-checkbox sl-checkbox-radio sl-checkbox-circle sl-radio-md sl-m-0 sl-cursor-pointer"/>


                        </td>

                        <td className="sl-font sl-cursor-pointer sl-display-flex sl-justify-center sl-font-medium sl-text-sm sl-py-16 sl-pr-16 sl-pl-16 sl-w-28 sl-min-w-28 sl-text-start sl-relative">
                            <SwitchButton
                                checked={item.visibility}
                                onChange={async (checked) => {
                                    await setReviewVisibility(item.id, checked);
                                }}
                            />
                        </td>
                    </tr>
                }
            )}
            </tbody>
        </table>

        {tablePagination?.total > 0 && <div
            className="sl-flex sl-p-2 sl-justify-between sl-align-center sl-gap-3 sl-h-16 sl-border sl-border-solid sl-border-gray-200 sl-border-top-none sl-rounded-bottom-left-lg sl-rounded-bottom-right-lg sl-bg-white sl-shadow-md sl-pt-12 sl-pb-16 sl-px-24">
            <button
                onClick={() => setCurrentPage(currentPage - 1)}
                className="sl-flex sl-justify-center sl-align-center sl-gap-2 sl-h-11 sl-w-max-content sl-btn sl-btn-sm sl-btn-tertiary sl-shadow-xs sl-font sl-font-medium sl-text-md"
                disabled={tablePagination.current_page === 1}>
                <ArrowLeft size={20}/>
                <span>Previous</span>
            </button>

            <span className="sl-font sl-font-normal sl-text-sm sl-text-gray-700">Page <span
                className="sl-font-medium">{tablePagination.current_page}</span> of <span
                className="sl-font-medium">{tablePagination.total_pages}</span></span>

            <button
                onClick={() => setCurrentPage(currentPage + 1)}
                className="sl-flex sl-justify-center sl-align-center sl-gap-2 sl-h-11 sl-w-max-content sl-btn sl-btn-sm sl-btn-tertiary sl-shadow-xs sl-font sl-font-medium sl-text-md"
                disabled={tablePagination.current_page === tablePagination.total_pages}>
                <span>Next</span>
                <ArrowRight size={20}/>
            </button>
        </div>}

    </>
}

export default ReviewsTable;
